<div id="mybets" class="mybets-redesign" [ngClass]="{ 'mybets-betcard-redesign': !isEditBetHistory() && myBetsUtilService.isBetCardRedesigned() }">
    <ng-container *ngIf="isEditBetHistory(); else myBetsList">
        <ms-my-bets-edit-bet-history-header />
        <ms-my-bets-edit-bet-history-list [myBetsListContext]="myBetsListContext" />
    </ng-container>
</div>

<ng-template #myBetsList>
    <ng-container *ngIf="isInitalLoadReady; else loading">
        <ng-container *ngIf="hasBetslips && data.betslips; else empty_list">
            <div class="help-container help-aligned">
                <ms-help-box
                    boxType="autocashout"
                    class="help-auto-cachout"
                    *ngIf="isAutoCashoutHelpBoxVisible"
                    (closeButtonClick)="onAutoCashoutHelpBoxClose()"
                    (infoIconClick)="onAutoCashoutHelpInfoIconClick()" />
            </div>

            <ms-my-bets-list
                [listType]="listType"
                [betslips]="data.betslips"
                [myBetsListContext]="myBetsListContext"
                [earlyPayoutSubscription]="earlyPayoutService"
                (requestMore)="loadMoreBetSlips()"
                (pinningAnimate)="onBetPinned($event)"
                (unpinningAnimate)="onBetUnpinned()" />
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #loading>
    <div class="mybets-empty popup-body"></div>
</ng-template>

<ng-template #empty_list>
    <ms-my-bets-empty-list [listType]="listType" [errorLoadingBets]="data.errorLoadingBets" [myBetsListContext]="myBetsListContext" />
</ng-template>
